<template>
  <div class="documents-vehicles">
    <h1>Driver Documents</h1>
    <b-row>
      <b-col cols="12">
        <div class="panel">
          <div class="panel-heading">
            <h3 class="panel-title">Documents</h3>
          </div>
          <div class="panel-body">
            <documents ref="documentList" :docErrors="errorDoc" docType="driver" :docList="driverDocuments" @saveDocCallback="saveDocument" @updateCallback="updateDocument"/>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import documents from "@/components/documents.vue";
import shebahApi from "@/services/shebah/index";
export default {
  name: "dashboard",
  components: {
    documents
  },
  computed: {},
  data() {
    return {
      driverDocuments:{},
      errorDoc:{}
    };
  },
  watch:{},
  created() {
    this.getdocuments();
  },
  methods: {
    async getdocuments(){
      this.driverDocuments=await shebahApi.api.documents.driverDocuments();
    },
    async saveDocument(document){
      try{
          await shebahApi.api.documents.saveDocuments(
              document.key,
              document.data
            );
            this.errorDoc = null;
            await this.getdocuments();
            this.$store.dispatch("authUser/getAlerts");
            await shebahApi.api.users.get();
      }catch(e){
        if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        }
      }
    },
    async updateDocument(document){
      try{
      await shebahApi.api.documents.updateDocument(
              document.key,
              document.data
            );
            this.errorDoc = null;
            await this.getdocuments();
            this.$store.dispatch("authUser/getAlerts");
            await shebahApi.api.users.get();
      }catch(e){
        if (e.response) {
          if (
            typeof e.response.data.error !== "undefined" &&
            typeof e.response.data.error.collection !== "undefined"
          ) {
            this.errorDoc = e.response.data.error.collection;
          }
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
